const angular = require("angular");
const amt_admin = require("amt_admin").default;
const app = angular.module("ww2_analytics.offers", [amt_admin]);

app.service("offers_api", [
  "jsonrpc",
  function (jsonrpc) {
    const service = jsonrpc.newService("offers");
    this.offer_data = service.createMethod("offer_data");
    this.offers_chain_data = service.createMethod('offers_chain_data');
  }
]);

app.config([
  "$stateProvider",
  function ($stateProvider) {
    $stateProvider
      .state("amt.ww2.offers", {
        url: "/offers",
        abstract: true,
        template: "<div class='row'><div class='col-md-12' ui-view></div></div>",
        data: {
          priority: 800,
          title: "Offer",
          role: "offers",
        },
        menu: {
          fa: "usd",
          childs: [
//            {
//              state: "amt.ww2.offers.offer",
//              fa: "usd"
//            },
            {
              state: "amt.ww2.offers.offers_see_activity",
              fa: "usd",
            },
            {
              state: "amt.ww2.offers.ad_offer_popups",
              fa: "usd",
            },
            {
              state: "amt.ww2.offers.inapp_offer_popups",
              fa: "usd",
            },
            {
              state: "amt.ww2.offers.offers_chain",
              fa: "usd",
            },
          ]
        }
      })
      .state("amt.ww2.offers.offer", require('./offer').default)
      .state('amt.ww2.offers.offers_see_activity', require('./offers_see_activity').default)
      .state("amt.ww2.offers.inapp_offer_popups", require("./inapp_offer_popups").default)
      .state("amt.ww2.offers.ad_offer_popups", require("./ad_offer_popups").default)
      .state("amt.ww2.offers.offers_chain", require("./offers_chains").default)
  }
]);

export default app.name;
